// 演示目录 API 封装 / Demos catalog API facade
import { api, buildApiUrl } from "@/api/client";
import type { ReportPreviewRequest, ReportPreviewResponse } from "@/api/reports";
import type { Mode } from "@/lib/types";

// 演示目录响应 / Demo catalog response.
export interface DemoCatalog {
  ok: true;
  single: Array<{
    id: string;
    title: string;
    description: string;
    defaults: Record<string, unknown>;
    plan_markdown: string;
    plan_summary: Record<string, unknown>;
    report_slug?: string | null;
  }>;
  ab: Array<{
    id: string;
    title: string;
    description: string;
    defaults: Record<string, unknown>;
    plan_a_markdown: string;
    plan_b_markdown: string;
    plan_a_summary: Record<string, unknown>;
    plan_b_summary: Record<string, unknown>;
    report_slug?: string | null;
  }>;
  reports: Array<{
    id: string;
    slug?: string;
    title: string;
    demo_simulation_slug?: string | null;
    schema_version?: string | null;
  }>;
}

// 单个演示详情响应 / Single demo detail response.
export interface DemoDetail {
  ok: true;
  item: {
    slug: string;
    mode: Mode;
    title: string;
    description: string;
    plan_a_md: string;
    plan_b_md: string | null;
    config: Record<string, unknown>;
    report_slug: string | null;
  };
}

// 静态演示报告响应 / Static demo report response.
export interface DemoReportDetail {
  ok: true;
  item: {
    slug: string;
    title: string;
    markdown: string;
    demo_simulation_slug: string | null;
    schema_version?: string | null;
    payload?: Record<string, unknown> | null;
    download_urls?: { markdown: string; html?: string; pdf?: string };
  };
}

export const demosApi = {
  list: () => api.get<DemoCatalog>("/api/v1/demos"),
  get: (slug: string) => api.get<DemoDetail>(`/api/v1/demos/${encodeURIComponent(slug)}`),
  getReport: (slug: string) =>
    api.get<DemoReportDetail>(`/api/v1/demo-reports/${encodeURIComponent(slug)}`),
  preview: (slug: string, _body: ReportPreviewRequest) =>
    api.get<ReportPreviewResponse>(`/api/v1/demo-reports/${encodeURIComponent(slug)}/preview`),
  demoReportDownloadUrl: (slug: string) =>
    buildApiUrl(`/api/v1/demo-reports/${encodeURIComponent(slug)}/download.md`),
};
